<template>
  <div>
  <header id="purple-header" class="logado">
      <div class="logo">
         <router-link :to="isLogged ? '/recarga' : '/login'">
          <img src="../assets/img/logoGiro.svg" alt="">
         </router-link>
      </div>
      <div class="lang">
        <a v-on:click="setIdioma('ptBR')" v-if="!isIdioma('ptBR')"><img src="../assets/img/idioma-pt.png" alt="Português"><span>{{ t('PORTUGUES') }}</span></a>
        <a v-on:click="setIdioma('enUS')" v-if="!isIdioma('enUS')"><img src="../assets/img/idioma-en.png" alt="Ingles"><span>{{ t('INGLES') }}</span></a>
      </div>
      <nav v-if="!checkRoute('retornopagamento')">
          <ul>
              <li data-path="bilhete-especial" :class="(checkRoute('bilhete-especial')) && 'active'" v-if="!!current">
                <div appEvent="true" appEventCategory="menu" appEventLabel="bilhete-especial" @click="$router.push({name:'bilhete-especial'})">
                    <img src="../assets/img/qrcode.svg" alt="">
                    <a v-if="!isMobile()">{{ current.nome }}</a>
                </div>
              </li>
              <li data-path="home" :class="( checkRoute('home') || checkRoute('login')) && 'active'">
                
                <div  appEvent="true" appEventCategory="menu" appEventLabel="recarga" @click="renewRoute()">
                    <Money :width="returnHeight" :height="returnHeight" iconColor="white"/>
                    <a v-if="!isMobile()">{{ t('RECARGA') }}</a>
                </div>
              </li>
              <li data-path="vantagens"  :class="checkRoute('vantagens') && 'active'">
                  <div appEvent="true"  appEventCategory="menu" appEventLabel="meus dados" @click="$router.push({name:'vantagens'})">
                    <img src="../assets/img/vantagens.svg" alt="">
                    <a v-if="!isMobile()">{{ t('VANTAGENS') }}</a>
                  </div>
              </li>
               <li data-path="extrato"  v-if="isLogged" :class="checkRoute('extrato') && 'active'"> 
                <div data-path="extrato" appEvent="true" appEventCategory="menu" appEventLabel="extrato" @click="$router.push({name:'extrato'})">
                  <img src="../assets/img/meus dados.svg" alt="">
                  <a v-if="!isMobile()">{{ t('EXTRATO') }}</a>   
                </div>
              </li>
               <li data-path="dados"  v-if="isLogged"  :class="checkRoute('dados') && 'active'"> 
                    <div appEvent="true"  appEventCategory="menu" appEventLabel="meus dados" @click="$router.push({name:'dados'})">
                      <img src="../assets/img/user.svg" alt="">
                      <a v-if="!isMobile()">{{ t('MEUS_DADOS') }}</a>
                    </div>
              </li>
              <li data-path="ajuda" :class="checkRoute('ajuda') && 'active'">
                    <div appEvent="true"  appEventCategory="menu" appEventLabel="ajuda" @click="$router.push({name:'ajuda'})">
                      <img src="../assets/img/ajuda.svg" alt="">
                      <a v-if="!isMobile()">{{ t('AJUDA') }}</a>
                    </div>
              </li>
               <li  v-if="isLogged" >
                  <div appEvent="true" appEventCategory="mais" appEventLabel="sair" @click="logout()">
                    <Logout :width="returnHeight" :height="returnHeight" iconColor="white"/>
                    <a >{{ t('SAIR') }}</a>
                  </div>
              </li>
              <li class="hamburguer">
                  <div >
                  </div>
              </li>
          </ul>
      </nav>
  <input type="checkbox" class="openSidebarMenu" id="openSidebarMenu">
  <label for="openSidebarMenu" class="sidebarIconToggle">
    <div class="spinner diagonal part-1"></div>
    <div class="spinner horizontal"></div>
    <div class="spinner diagonal part-2"></div>
  </label>
  <div id="sidebarMenu">
    <ul class="sidebarMenuInner">
      <li data-path="bilhete-especial"  v-if="!!current">      
        <div  appEvent="true" appEventCategory="menu" appEventLabel="bilhete-especial" @click="changeMenu('bilhete-especial')">
            <a>{{ current.nome }}</a>
        </div>
      </li>
          <li data-path="home" >      
                <div  appEvent="true" appEventCategory="menu" appEventLabel="recarga" @click="renewRoute()">
                    <a>{{ t('RECARGA') }}</a>
                </div>
              </li>
              <li data-path="vantagens" >
                  <div appEvent="true"  appEventCategory="menu" appEventLabel="vantagens" @click="changeMenu('vantagens')">
                    <a>{{ t('VANTAGENS') }}</a>
                  </div>
              </li>
               <li data-path="extrato" v-if="isLogged"> 
                <div data-path="extrato" appEvent="true" appEventCategory="menu" appEventLabel="extrato" @click="changeMenu('extrato')">
                  <a>{{ t('EXTRATO') }}</a>   
                </div>
              </li>
               <li data-path="dados" v-if="isLogged"> 
                    <div appEvent="true"  appEventCategory="menu" appEventLabel="meus dados" @click="changeMenu('dados')">
                      <a>{{ t('MEUS_DADOS') }}</a>
                    </div>
              </li>
              <li data-path="ajuda"  >
                    <div appEvent="true"  appEventCategory="menu" appEventLabel="ajuda" @click="changeMenu('ajuda')">
                      <a>{{ t('AJUDA') }}</a>
                    </div>
              </li>
               <li v-if="isLogged">
                  <div  appEvent="true" appEventCategory="mais" appEventLabel="sair" @click="logout()">
                    <a >{{ t('SAIR') }}</a>
                  </div>
              </li>
    </ul>
  </div>
  </header>
  <PopupMessage v-on:closePopup="()=>emitToParent('closePopup',this)" v-bind="popupObject"/>
  </div>
</template>

<script>
import {emitToParent, redirect,removeToken,isMobile} from '../helpers/helpers'
import PopupMessage from '@/components/PopupMessage.vue'
import Money from '@/components/svg/Money.vue'
/*import Ticket from '@/components/svg/Ticket.vue'
import Book from '@/components/svg/Book.vue'
import User from '@/components/svg/User.vue'
import Info from '@/components/svg/Info.vue'*/
import Logout from '@/components/svg/Logout.vue'
import { translate, setIdioma, isIdioma } from '../services/translate.service';

export default {
  name: 'Header',
  components: {
    Money,
    /*Ticket,
    Book,
    User,
    Info,*/
    Logout,
    PopupMessage
  },
  computed:{
    returnHeight(){
      return window.innerwidth < 480 ? 30 : 40
    },
    current() {
      return this.$store.state.qrcode_current || null;
    }
  },
  props:{
    isLogged:{
      type:Boolean,
      default:false
    },
    popupObject:{
      type:Object
    },
    rotaAtual:{
      type:String
    }
  },
  watch:{
    $route ({name:atual}, {name:antigo}){
      console.log({atual,antigo})
      if(antigo === atual) return 
      if(atual.toLowerCase() === "login"){ 
        atual = "home"
        this.$emit('logout')
      }
      if(atual.toLowerCase() === "faleconosco") atual = "ajuda"
      if(antigo && antigo.toLowerCase() === "login") antigo = "home"
      if(antigo && antigo.toLowerCase() === "faleconosco") antigo = "ajuda"
      try{
        if(document.querySelector("li[data-path='"+antigo+"']") && document.querySelector("li[data-path='"+antigo+"']").classList)
          document.querySelector("li[data-path='"+antigo+"']").classList.remove('active')
        if(document.querySelector("li[data-path='"+atual+"']") && document.querySelector("li[data-path='"+atual+"']").classList)
          document.querySelector("li[data-path='"+atual+"']").classList.add('active')
      }
      catch(error){
        console.log(error)
      }
    }
  }, 
  methods:{
    t: translate,
    isIdioma,
    setIdioma,
    isMobile,
    emitToParent,
    checkRoute(route){
      if(!this.rotaAtual && route === "home") return true 
      if(route == 'bilhete-especial' && this.rotaAtual.indexOf('bilhete-especial') != -1) return true;
      if(route == 'ajuda'){
        if(this.rotaAtual == 'termos-de-uso') return true;
        if(this.rotaAtual == 'politica-privacidade') return true;
      }
      return this.rotaAtual === route
    },
    renewRoute(){
      Array.from(document.querySelectorAll('.openSidebarMenu')).forEach((menu) => menu.checked = false);
      if(this.$router.currentRoute.name !== "home" && this.isLogged) redirect("home",this)
      else if(!this.isLogged) this.$router.push('login')
      else emitToParent("reloadPageId",this)
    },
    changeMenu(name){
      Array.from(document.querySelectorAll('.openSidebarMenu')).forEach((menu) => menu.checked = false);
      this.$router.push({name})
    },
    logout(){
      Array.from(document.querySelectorAll('.openSidebarMenu')).forEach((menu) => menu.checked = false);
      removeToken()
      this.$emit('logout')
      redirect("login",this)
    }
  },
  created(){
  }
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/header.scss";
  svg{
    display: block;
  }
</style>
